<template>
   <ion-page id="lichessarena-page">
    <ion-content>
      <TopLine :style="styleTopline" title="Lichess Connect" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>
      <div :style="styleMiddle" id="lichess_connect">
        <ion-item>
          <ion-label>
            <h1>{{  title }}</h1>
          </ion-label>
        </ion-item>
        <ion-item>
          <div v-html="message"></div>
        </ion-item>
      </div>
      <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
    </ion-content>
  </ion-page>
  
</template>

<script setup>

  import { IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';
  import { computed } from "@vue/reactivity"

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight,  scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  import { ref, watch } from 'vue'
  import ToolBar from '@/components/ToolBar.vue'
  import TopLine from '@/components/TopLine.vue'
  import { useRouter } from 'vue-router';
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { v4 as uuidv4 } from 'uuid';
  import { useGetData, getWebSiteURL } from '../../composables/getData.js'
  import SingleOption from '@/components/SingleOption.vue'
  import { parseWordsSaid , parseGeneralWordsSaid } from '@/composables/wordlistSupport.js'

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  var lichessUserid = ""
  var lichessVerifier = ""
  var lichessUUID = ""
  var lichessAccessToken = connectionStore.getLichessAccessToken

  const isDark = ref(connectionStore.getDarkmode != "light")

  const wordlist = ref("command done connect ignore")
  const wordlistTrigger = ref(0)

  const title = ref("Connect to Lichess")
  const message = ref("Say 'command connect' to bring up a lichess.org screen where you'll indicate to Lichess that 'Verbal Chess' has permission to play using your Lichess account. (Some browser's require an actual 'click' on the 'Connect' button to bring up the Lichess webpage.)<p>Note: the speech recognizer doesn't help with the Lichess Login.")

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const TOOLBAR_CONNECT = 0

  const toolbarElements = ref([
    { index : TOOLBAR_CONNECT, label : "Connect" ,disabled : false},
  ])
  const toolbarTrigger = ref(0)

  watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

   watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  function afterStartupCallbackRoutine(stuffChanged) {
    getLichessVerifer()
  }


 function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  // START Explain Tour Routines

  function explainTourInitialize(errorText) {
    showState.value = SHOW_EXPLAINTOUR
    explainTourScreen.value = (errorText == null) ? "lichess_connect" : ("ERROR:" + errorText);
    wordlist.value = connectionStore.getExplainTourWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
  }

  function explainTourToolbarClick(whatClicked) {
    switch (whatClicked) {

      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        showState.value = SHOW_MENU
        wordlist.value = wordlistMenu
        emit("word-list",wordlist.value)

        wordlistTrigger.value++
        break
    }
  }

  // END Explain Tour Routines

  function toolbarClick(arrayIndex) {
    if (arrayIndex == 0)
      processWords("command connect")
    else
      processWords("command done")
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "connect") {
            return ["connect",""]
        }
        if (currentWord == "done") {
            return ["done",""]
        }
       
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return (["ignore",""]);
  }

  function processWords(text) {
    //console.log("text in Connect ",text)
    var returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "connect" :
        //console.log("********* CONNECT")
        connectToLichess()
        break
      case "done" :
        emit("where-next","/lichessmenu")
        //router.replace({ path: "/lichessmenu"})
        break
    }
  }

  function connectToLichess() {
    // const urlRaw = "https://oauth.lichess.org/oauth/authorize?scope=board:play%20challenge:write%20tournament:write%20follow:read&redirect_uri=https://www.chessvis.com/lichess_callback.php&client_id=cZblLKMuqXbkgzTq&response_type=code&state=" +
    //               uuid

    const webURL = getWebSiteURL()
    //const callbackProgram = (import.meta.env.MODE === 'production') ? 
    //                                    "lichess_prod_callback.php" : "lichess_dev_callback.php"

    const callbackProgram = "lichess_prod_callback.php"
    const responseType = "response_type=code"
    const clientId = "&client_id=verbalchess.fun"
    const redirectUri = "&redirect_uri=" + webURL + callbackProgram
    const codeChallengeMethod = "&code_challenge_method=S256"
    const codeChallenge = "&code_challenge=" + lichessVerifier
    const scope = "&scope=board:play%20challenge:write%20tournament:write%20follow:read"
    const state = "&state=" + lichessUUID

    const urlRaw = "https://lichess.org/oauth?" +
                responseType + redirectUri + clientId + codeChallengeMethod + codeChallenge + scope + state
    
    // console.log("responseType",responseType)
    // console.log("clientId",clientId)
    // console.log("redirectUri",redirectUri)
    // console.log("challengeMethod",codeChallengeMethod)
    // console.log("codeChallenge",codeChallenge)
    // console.log("scope",scope)
    // console.log("state",state)
    //console.log("URL ->",urlRaw)
    
    window.open(urlRaw)
  }


  function processJsonResponse (json) {
    //console.log(" in lichess menu callback",json)
    if (json.hasOwnProperty('error')) {
      showState.value = SHOW_EXPLAIN
      explainTitle.value = "*** ERROR ALERT ***"
      explainMessage.value = generateErrorAlertText(json)
      return;
    }
    
    lichessVerifier = json['verifier']

  }

  function getLichessVerifer() {

    lichessUUID = uuidv4().replace(/-/g,"")

    var formData = {
      u : lichessUUID
    }

    // get151_verbal_lichess_token.php
    
    useGetData("getweb_verbal_lichess_token.php", formData, processJsonResponse)
  }

</script>

<style scoped>

</style>